import React from 'react'
import { Link } from 'react-router-dom'
import Breadcrumb from '../../components/common/Breadcrumb'
import {
  blogImage1, blogImage2, blogImage3, blogImage4,
} from '../../assets/images'
import {
  IconHeart,
  IconMessage2,
} from '@tabler/icons-react'
import BlogSidebar from '../../components/blog/BlogSidebar'

export default function BlogList() {

  const blogList = [
    {
      image: blogImage1,
      title: "All photographs are accurate",
      content: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal",
      buttonTitle: "Continue Reading",
      url: "/blog-detail",
      category: "General",
      like: "28",
      comment: "128",
    },
    {
      image: blogImage2,
      title: "All photographs are accurate",
      content: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal",
      buttonTitle: "Continue Reading",
      url: "/blog-detail",
      category: "General",
      like: "28",
      comment: "128",
    },
    {
      image: blogImage3,
      title: "All photographs are accurate",
      content: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal",
      buttonTitle: "Continue Reading",
      url: "/blog-detail",
      category: "General",
      like: "28",
      comment: "128",
    },
    {
      image: blogImage4,
      title: "All photographs are accurate",
      content: "It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that it has a more-or-less normal",
      buttonTitle: "Continue Reading",
      url: "/blog-detail",
      category: "General",
      like: "28",
      comment: "128",
    },
  ]

  return (
    <>
      <Breadcrumb title="Blog List" path="Blog / Blog List" />
      <div className='grid lg:grid-cols-[8fr_4fr] grid-cols-1 gap-30'>
        <div>
          {blogList.map((item, key) => (
            <div key={key} className='bg-bg-dark rounded-lg shadow-light lg:p-30 md:p-20 p-15 mb-30 last:mb-0'>
              <Link to={item.url} className='flex group overflow-hidden'>
                <img src={item.image} width="1100" height="600" alt='blog post' className='w-full lg:h-[500px] object-cover transition-all duration-700 group-hover:scale-[1.02] group-hover:grayscale' />
              </Link>
              <Link to={item.url} className='uppercase text-[20px]/[22px] font-medium md:mt-30 mt-20 line-clamp-1'>
                {item.title}
              </Link>
              <p className='mt-10 text-[16px]/[26px] text-text-secondary line-clamp-2'>
                {item.content}
              </p>
              <div className='md:mt-30 mt-20 flex items-center justify-between flex-wrap gap-15'>
                <Link to={item.url} className="btn btn-secondary">
                  {item.buttonTitle}
                </Link>
                <div className='text-text-secondary flex items-center gap-20'>
                  <span className='uppercase transition-all duration-300 hover:text-primary'>
                    {item.category}
                  </span>
                  <span>|</span>
                  <button className='flex items-center gap-5 transition-all duration-300 hover:text-primary'>
                    <IconHeart className='w-[16px] h-[16px] stroke-[1.5]' />
                    {item.like}
                  </button>
                  <span>|</span>
                  <button className='flex items-center gap-5 transition-all duration-300 hover:text-primary'>
                    <IconMessage2 className='w-[16px] h-[16px] stroke-[1.5]' />
                    {item.comment}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
        <BlogSidebar />
      </div>
    </>
  )
}
